import { bootTool } from '../../core/boot';
import { mountUrlAnalysis } from './ui';

bootTool('[data-kb-tool="suspicious-url-analyzer"]', mountUrlAnalysis);
